import { SignIn } from '@clerk/clerk-react'
import {CenteredElement} from "../components/CenteredElement";

export const SignInPage = () => {
    return (
        <CenteredElement><SignIn path="/sign-in" fallbackRedirectUrl={document.referrer}/></CenteredElement>
    )
}